import { render } from "./role_manage.vue?vue&type=template&id=2df855cf"
import script from "./role_manage.vue?vue&type=script&lang=js"
export * from "./role_manage.vue?vue&type=script&lang=js"

import "./role_manage.vue?vue&type=style&index=0&id=2df855cf&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__